import { Pipe, PipeTransform } from '@angular/core';
import {RegularUnitAdvertisementDto} from "homey-housing-lottery-app-dto";

@Pipe({
  name: 'estimatedSavings',
  standalone: true
})
export class EstimatedSavingsPipe implements PipeTransform {
  transform(advertisements: RegularUnitAdvertisementDto[]): number[] {
    return advertisements.map(
      unit => unit.estimatedSavings
    );
  }
}
